export default{
  label:'width',
  valueScope:[
    'w-25',
    'w-50',
    'w-75',
    'w-100',
    'vw-100',
    'mw-100',
    'min-vw-100',
  ],
}



// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/sizing/width.js